import { Global } from "../../Global";


const mockHeadImage= "https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/ed/ed4e27c042b3a942e87151292cd17e84a62406828064632b50c18c1f114e1ae2.jpg"
const mockPdfUrl= "https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/c1/c1c4d2abd04abc0764519a0d6caacff9d3fe1775fc2a210aa94ef5bfbda166f3.pdf"

// Mock 数据定义
Global.setMockData("getOrdersAfterTime", [
    {
        orderId: "ORDER_001",
        productId: "PROD_001",
        productSnapshot: {
            name: "网站前端开发项目",
            headImageUrl: mockHeadImage,
            description: "需要开发一个响应式电商网站的前端界面，包含用户登录、商品展示、购物车、订单管理等功能模块。"
        },
        specificationType: 1,
        price: 5000,
        quantity: 1,
        status: 2,
        orderTime: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
        startTime: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
        buyerId: "BUYER_001",
        sellerId: "10002",
        demandDescription: "需要开发一个响应式电商网站的前端界面，包含用户登录、商品展示、购物车、订单管理等功能模块。",
        pdfContractList: ["CONTRACT_001"],
        quickContractList: ["QUICK_001"]
    },
    {
        orderId: "ORDER_002",
        productId: "PROD_002",
        productSnapshot: {
            name: "移动应用UI设计",
            headImageUrl: mockHeadImage,
            description: "为iOS和Android应用设计现代化的用户界面，需要符合Material Design和iOS设计规范。"
        },
        specificationType: 1,
        price: 3000,
        quantity: 1,
        status: 1,
        orderTime: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
        buyerId: "BUYER_002",
        sellerId: "10002",
        demandDescription: "为iOS和Android应用设计现代化的用户界面，需要符合Material Design和iOS设计规范。",
        pdfContractList: ["CONTRACT_002"]
    },
    {
        orderId: "ORDER_003",
        productId: "PROD_003",
        productSnapshot: {
            name: "数据分析报告撰写",
            headImageUrl: mockHeadImage,
            description: "基于用户行为数据，撰写详细的数据分析报告，包含用户画像、行为分析、转化漏斗等分析内容。"
        },
        specificationType: 1,
        price: 2000,
        quantity: 1,
        status: 4,
        orderTime: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
        startTime: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000),
        deliveryTime: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
        agreeTime: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
        buyerId: "BUYER_003",
        sellerId: "10003",
        demandDescription: "基于用户行为数据，撰写详细的数据分析报告，包含用户画像、行为分析、转化漏斗等分析内容。",
        pdfContractList: ["CONTRACT_003"]
    }
]);

Global.setMockData("getOrderDetail_ORDER_001", {
    orderId: "ORDER_001",
    productId: "PROD_001",
    productSnapshot: {
        name: "网站前端开发项目",
        headImageUrl: mockHeadImage,
        description: "需要开发一个响应式电商网站的前端界面，包含用户登录、商品展示、购物车、订单管理等功能模块。"
    },
    specificationType: 1,
    price: 5000,
    quantity: 1,
    status: 2,
    orderTime: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
    startTime: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
    buyerId: "BUYER_001",
    sellerId: "10002",
    demandDescription: "需要开发一个响应式电商网站的前端界面，包含用户登录、商品展示、购物车、订单管理等功能模块。",
    pdfContractList: ["CONTRACT_001"],
    quickContractList: ["QUICK_001"]
});

Global.setMockData("getOrderDetail_ORDER_002", {
    orderId: "ORDER_002",
    productId: "PROD_002",
    productSnapshot: {
        name: "移动应用UI设计",
        headImageUrl: mockHeadImage,
        description: "为iOS和Android应用设计现代化的用户界面，需要符合Material Design和iOS设计规范。"
    },
    specificationType: 1,
    price: 3000,
    quantity: 1,
    status: 1,
    orderTime: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
    buyerId: "BUYER_002",
    sellerId: "10002",
    demandDescription: "为iOS和Android应用设计现代化的用户界面，需要符合Material Design和iOS设计规范。",
    pdfContractList: ["CONTRACT_002"]
});

Global.setMockData("getOrderDetail_ORDER_003", {
    orderId: "ORDER_003",
    productId: "PROD_003",
    productSnapshot: {
        name: "数据分析报告撰写",
        headImageUrl: mockHeadImage,
        description: "基于用户行为数据，撰写详细的数据分析报告，包含用户画像、行为分析、转化漏斗等分析内容。"
    },
    specificationType: 1,
    price: 2000,
    quantity: 1,
    status: 4,
    orderTime: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
    startTime: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000),
    deliveryTime: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
    agreeTime: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
    buyerId: "BUYER_003",
    sellerId: "10003",
    demandDescription: "基于用户行为数据，撰写详细的数据分析报告，包含用户画像、行为分析、转化漏斗等分析内容。",
    pdfContractList: ["CONTRACT_003"]
});

Global.setMockData("queryPdfContractById_CONTRACT_001", {
    contractId: "CONTRACT_001",
    contractName: "网站前端开发项目合同",
    contractNo: "CTR_2024_001",
    pdfUrl: mockPdfUrl,
    signTime: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    signerId: "10002",
    signerName: "测试用户1",
    posterId: "BUYER_001",
    posterName: "张老板",
    postTime: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    posterSignTime: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString()
});

Global.setMockData("queryPdfContractById_CONTRACT_002", {
    contractId: "CONTRACT_002",
    contractName: "移动应用UI设计合同",
    contractNo: "CTR_2024_002",
    pdfUrl: mockPdfUrl,
    signTime: "",
    signerId: "10002",
    signerName: "测试用户1",
    posterId: "BUYER_002",
    posterName: "李设计师",
    postTime: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    posterSignTime: ""
});

Global.setMockData("queryPdfContractById_CONTRACT_003", {
    contractId: "CONTRACT_003",
    contractName: "数据分析报告撰写合同",
    contractNo: "CTR_2024_003",
    pdfUrl: mockPdfUrl,
    signTime: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
    signerId: "10003",
    signerName: "测试用户2",
    posterId: "BUYER_003",
    posterName: "王经理",
    postTime: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    posterSignTime: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString()
});

Global.setMockData("queryQuickContractById_QUICK_001", {
    contractId: "QUICK_001",
    contractName: "网站前端开发项目闪电合约",
    contractNo: "QTR_2024_001",
    posterId: "BUYER_001",
    posterName: "张老板",
    posterSignTime: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    posterSignUrl: "https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/ed/ed4e27c042b3a942e87151292cd17e84a62406828064632b50c18c1f114e1ae2.jpg",
    signerId: "10002",
    signerName: "测试用户1",
    signerSignTime: "",
    signerSignUrl: "",
    postTime: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    content: "甲方委托乙方完成网站前端开发，双方确认本闪电合约具备法律效力。",
    status: 0
});